import { format as fnsFormat, isToday, isYesterday, toDate } from 'date-fns';

import type { useTranslations } from 'next-intl';

export function parseDate(date: string | Date | null | undefined): Date {
  if (!date) {
    return new Date();
  }

  if (typeof date === 'string') {
    return toDate(Date.parse(date));
  }

  return date;
}

type TDefaultFormat =
  | 'dd/MM/yyyy'
  | 'MM/dd/yyyy'
  | 'MMM d, yyyy HH:mm a'
  | 'dd MMM yyyy';

interface IOptionsProps {
  defaultValue?: string;
  format?: TDefaultFormat | Omit<string, TDefaultFormat>;
}

export function formatDate(
  value: string | Date | null | undefined,
  opts: IOptionsProps = {},
): string {
  const { format = 'dd/MM/yyyy', defaultValue = '' } = opts;

  if (!value) {
    return defaultValue;
  }

  return fnsFormat(parseDate(value), format as string);
}

export function getChatFormattedDate(
  date: Date,
  t: ReturnType<typeof useTranslations>,
) {
  if (isToday(date)) {
    return t('days.today');
  } else if (isYesterday(date)) {
    return t('days.yesterday');
  } else {
    const dayOfWeek = t(`days.${fnsFormat(date, 'eeee').toLowerCase()}`);
    const month = t(`months.${fnsFormat(date, 'MMMM').toLowerCase()}`);
    const day = fnsFormat(date, 'd');
    return `${dayOfWeek}, ${month} ${day}`;
  }
}

export function parseUtcDateString(dateStr: string): Date {
  return new Date(dateStr.replace(' ', 'T').replace(' UTC', 'Z'));
}
